import React, { Component } from "react";
import PropTypes from "prop-types";
import { Form, Dropdown } from "semantic-ui-react";

class YearSelector extends Component {
  constructor(props) {
    super(props);
    // Default year level options
    this.yearOptions = [
      { key: "1", value: "1", text: "1st Year" },
      { key: "2", value: "2", text: "2nd Year" },
      { key: "3", value: "3", text: "3rd Year" },
      { key: "4", value: "4", text: "4th Year" },
      { key: "5", value: "5", text: "5th Year" },
      { key: "grad", value: "grad", text: "Graduate" },
    ];
  }

  // Helper method to ensure user's current year is in options
  getEnhancedOptions = () => {
    const { value } = this.props;
    const options = this.yearOptions;
    if (!value) return options;
    // Check if current value exists in options
    const existingOption = options.find((opt) => opt.value === value);
    if (!existingOption && value) {
      // Add user's current year to options if not found
      return [
        ...options,
        {
          key: `current-${value}`,
          value: value,
          text: value,
        },
      ];
    }
    return options;
  };

  render() {
    const {
      value,
      onChange,
      required,
      placeholder,
      label,
      name,
      disabled,
      options,
    } = this.props;
    // Use provided options or enhanced default options
    const dropdownOptions = options || this.getEnhancedOptions();
    return (
      <Form.Field required={required}>
        {label && <label>{label}</label>}
        <Dropdown
          placeholder={placeholder}
          fluid
          selection
          name={name}
          value={value}
          options={dropdownOptions}
          onChange={onChange}
          disabled={disabled}
          className="year-selector"
        />
      </Form.Field>
    );
  }
}

YearSelector.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  options: PropTypes.array,
};

YearSelector.defaultProps = {
  value: "",
  required: false,
  placeholder: "Select Year",
  label: "Year",
  disabled: false,
  options: null,
};

export default YearSelector;
